import { render, staticRenderFns } from "./mita_detail.vue?vue&type=template&id=0c8d94f9&scoped=true&"
import script from "./mita_detail.vue?vue&type=script&lang=js&"
export * from "./mita_detail.vue?vue&type=script&lang=js&"
import style0 from "./mita_detail.vue?vue&type=style&index=0&id=0c8d94f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d94f9",
  null
  
)

export default component.exports